import * as React from "react";
import * as ReactTransitionGroup from "react-addons-transition-group";

import diyLightTheme = require("../../material-ui/diyLightTheme");
import TouchRipple from "material-ui/internal/TouchRipple";
import CircularProgress from "material-ui/CircularProgress";

import OverlayMenu from "./OverlayMenu";
import OverlayMenuConfig from "../interfaces/OverlayMenuConfig";

export enum OverlayStatus {
    HOVER,
    LOADING,
    ACTIVE
}

interface OverlayProps extends React.Props<Overlay> {
    width?: number;
    height?: number;
    left?: number;
    top?: number;
    zIndex?: number;
    overlayMenuConfig?: OverlayMenuConfig;
    status?: OverlayStatus;
    menuOpen?: boolean;
    cursor?: string;
    touchMode?: boolean;
    menuText: string;
    onMouseLeave?: (event: React.MouseEvent<{}>) => void;
    onMenuToggleRequest?: (open: boolean) => void;
}

export default class Overlay extends React.Component<OverlayProps, {}> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    getStyles() {
        return {
            root: {
                position: "absolute",
                zIndex: this.props.zIndex,
                cursor: this.props.cursor,
                left: this.props.left,
                top: this.props.top,
                width: this.props.width,
                height: this.props.height,
                background: 'rgba(33, 150, 243, 0.3)',
                boxSizing: 'border-box',
                border: '1px solid rgba(33, 150, 243, 1)',
            },
            border: {
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                boxSizing: 'border-box',
                border: '1px solid rgba(255, 255, 255, 1)'
            }
        };
    }

    render() {
        const styles = this.getStyles();
        let showMenuLabel = true;
        if ((this.props.width < 130)
            || ((this.props.width / 2) < 130 && this.props.height < 100)) {
                showMenuLabel = false;
            }
        let menuLabelMaxWidth = this.props.height > 100 ? this.props.width : (this.props.width * 75 / 100);

        return (
            <div className="wrapper"
                 style={styles.root}
                 onClick={this.handleClick}
                 onTouchTap={this.handleTouchTap}
                 onMouseLeave={this.props.onMouseLeave}
                 onContextMenu={this.handleRightClick}
            >
                <TouchRipple >
                <div style={styles.border} >
                    {
                        this.props.status === OverlayStatus.LOADING ?
                        <div>
                            <CircularProgress mode="indeterminate" size={1.5} />
                        </div>
                        :
                        null
                    }
                    <div onClick={e => e.stopPropagation()}
                         onMouseDown={e => e.stopPropagation()}
                         onTouchTap={e => e.stopPropagation()}
                    >
                        <ReactTransitionGroup>
                            <OverlayMenu
                                showMenuLabel={showMenuLabel}
                                menuLabelMaxWidth={menuLabelMaxWidth}
                                overlayMenuConfig={this.props.overlayMenuConfig}
                                open={this.props.menuOpen}
                                onToggleRequest={this.props.onMenuToggleRequest}
                                menuText={this.props.menuText}
                            />
                        </ReactTransitionGroup>
                    </div>
                </div>
                </TouchRipple>
            </div>
        );
    }

    private handleClick = (event: React.MouseEvent<{}>) => {
        if (!this.props.touchMode) {
            this.props.overlayMenuConfig.defaultAction();
        }
    };

    private handleTouchTap = (event: React.TouchEvent<{}>) => {
        if (this.props.touchMode) {
            this.props.overlayMenuConfig.defaultAction();
        }
    };

    private handleRightClick = (event: React.MouseEvent<{}>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.props.menuOpen && this.props.onMenuToggleRequest) {
            // XXX: Need the timeout to avoid an accidental menu option selection
            setTimeout(() => this.props.onMenuToggleRequest(true), 200);
        }
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/overlay/components/Overlay.tsx
 **/